/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosRichText, ResponsiveContainer, SectionContainer } from "@components/elements/atoms";
import { CollapsibleRichText } from "@components/elements/molecules/rich-text";
import { richTextContentStyles } from "@components/elements/ref-sections/rich-text";
import { PageLegalContentSectionsFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

const sectionStyles = css({ maxWidth: "100%" });

export const getLegalSections = (
	sections?: PageLegalContentSectionsFragment[] | null,
	isGameMode?: boolean,
): (React.JSX.Element | null | undefined)[] => {
	if (!sections || !sections.length) return [];
	return sections.map((section, i) => {
		if (!section || !section.__typename) return;

		switch (section.__typename) {
			case "CosmosElementCkEditorText":
				return (
					<div key={`ck-${i}`} className={cx(richTextContentStyles, sectionStyles)}>
						<CosmosRichText html={section?.ckText} isGameMode={isGameMode} />
					</div>
				);

			case "CosmosElementCkEditorTextCollapsible":
				return (
					<CollapsibleRichText key={`col-ck-${i}`} {...section} isGameMode={isGameMode} className={sectionStyles} />
				);

			default:
				return null;
		}
	});
};

interface Props {
	sections?: PageLegalContentSectionsFragment[];
	isGameMode?: boolean;
}

export const LegalContentSections = ({ sections = [], isGameMode }: Props): React.JSX.Element => {
	return (
		<ResponsiveContainer>
			<SectionContainer>
				<VStack id="legal-content-sections" gap="eds.dimension.48" alignItems={"flex-start"}>
					{getLegalSections(sections, isGameMode)}
				</VStack>
			</SectionContainer>
		</ResponsiveContainer>
	);
};
